
import {reactive} from 'vue'

export default {
  install(app, breakpoints = {}) {
    const state = reactive({})

    Object.entries(breakpoints).forEach(([key, query]) => {
      state[key] = false

      const mm = window.matchMedia(query)

      state[key] = mm.matches

      if (state[key]) document.body.classList.add(key)

      mm.addEventListener('change', e => {
        state[key] = e.matches
        document.body.classList.toggle(key, state[key])
      })
    })

    app.config.globalProperties.$responsive = state
  }
}